import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      
      <section>
        <h2>1. Agreement to Terms</h2>
        <p>
          By accessing and using our website, you agree to comply with and be bound by the following terms of service, 
          which together with our privacy policy govern [Your Company]'s relationship with you. If you disagree with any 
          part of these terms, you must not use our services.
        </p>
      </section>

      <section>
        <h2>2. Intellectual Property Rights</h2>
        <p>
          Unless otherwise stated, [Your Company] and/or its licensors own the intellectual property rights for all 
          material on this site. You may access content from our website for personal use, subject to restrictions 
          set in these terms.
        </p>
        <ul>
          <li>You must not republish material from this website.</li>
          <li>You must not sell, rent, or sub-license material from this website.</li>
          <li>You must not reproduce, duplicate, or copy content from this website.</li>
        </ul>
      </section>

      <section>
        <h2>3. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, in no event will [Your Company], its affiliates, directors, employees, 
          or agents be liable to you for any indirect, incidental, special, punitive, or consequential damages arising 
          out of or in connection with your use of the website or the services provided.
        </p>
      </section>

      <section>
        <h2>4. User Responsibilities</h2>
        <p>
          By using this site, you agree to use it for lawful purposes only. You agree not to use it in any way that 
          may violate any laws, infringe upon the rights of others, or cause damage to the site or its content.
        </p>
      </section>

      <section>
        <h2>5. Termination</h2>
        <p>
          We may terminate or suspend your access to the website immediately, without prior notice or liability, for 
          any reason, including if you breach these Terms.
        </p>
      </section>

      <section>
        <h2>6. Changes to Terms</h2>
        <p>
          We reserve the right to modify or replace these terms at any time. If a revision is made, we will notify 
          you via email or by posting the updated terms on this page.
        </p>
      </section>

      <section>
        <h2>7. Contact Information</h2>
        <p>
          If you have any questions about these Terms of Service, please contact us at [email address].
        </p>
      </section>
    </div>
  );
};

export default Terms;
